/**
 * Test ID utilities for Sheet component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Sheet trigger
 * @param identifier - Sheet identifier
 * @returns Test ID string
 */
export const setSheetTriggerTestId = (identifier: string): string =>
  generateTestId("SheetTrigger", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Sheet content
 * @param identifier - Sheet identifier
 * @returns Test ID string
 */
export const setSheetContentTestId = (identifier: string): string =>
  generateTestId("SheetContent", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Sheet title
 * @param identifier - Sheet identifier
 * @returns Test ID string
 */
export const setSheetTitleTestId = (identifier: string): string =>
  generateTestId("SheetTitle", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Sheet description
 * @param identifier - Sheet identifier
 * @returns Test ID string
 */
export const setSheetDescriptionTestId = (identifier: string): string =>
  generateTestId(
    "SheetDescription",
    identifier.replace(/\s+/g, "-").toLowerCase(),
  );

/**
 * Generate test ID for Sheet header
 * @param identifier - Sheet identifier
 * @returns Test ID string
 */
export const setSheetHeaderTestId = (identifier: string): string =>
  generateTestId("SheetHeader", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Sheet footer
 * @param identifier - Sheet identifier
 * @returns Test ID string
 */
export const setSheetFooterTestId = (identifier: string): string =>
  generateTestId("SheetFooter", identifier.replace(/\s+/g, "-").toLowerCase());
